import React from "react";
import { tokens } from "../../theme/theme";
import { Divider, Typography, Card, CardContent, Grid, CardHeader, IconButton, Button, useTheme, Box, } from "@mui/material";

import { useTranslation } from "react-i18next";

const SalesMenuIndex = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >


            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Sales Management </Typography>
                    </Box>
                </CardContent>
            </Card>


            {/* <Divider /> */}
            <Box p={2}>
                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >

                   <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Despatch Plan</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Despatch List")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Delivery Order </Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Delivery Order List")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Invoice </Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Invoice List")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Report Templates</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("ReportTemplates")}>Update</Button>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                            <Typography variant="h6" mt={2}>Sales Report</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("SalesReports")}>Update</Button>
                        </Card>
                    </Grid>


                </Grid>
            </Box>
        </Box>

    )
}
export default SalesMenuIndex;